import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Container, Row, Button, Spinner, Alert } from "react-bootstrap";
import api from "../services/httpClient";
import checkboxIcon from "../assets/images/check_box_rgb_red.svg";
import "../assets/styles/informationLayer.scss";
import AddressLayerData from "../components/Addresses/InformationLayer/AddressLayerData";
import InformationLayerData from "../components/Addresses/InformationLayer/InformationLayerData";
import InformationLayerMap from "../components/InformationLayerMap";
import ChangesHistory from "../components/Addresses/InformationLayer/ChangesHistory";
const Tab = ({ label, activeTab, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`tab ${activeTab === label ? "active" : ""}`}
    >
      {label}
    </div>
  );
};

const InformationLayer = () => {
  const { addressId } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Warstwa adresowa");
  const [addressData, setAddressData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!addressId) return console.log("No ID provided in URL params.");

    let active = true;
    const fetchAddressData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.get(`/Address/${addressId}`);
        if (!active) return;
        setAddressData(response.data);
      } catch (err) {
        if (!active) return;
        setError("Nie udało się pobrać danych adresu.");
        console.error(err);
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchAddressData();
    return () => {
      active = false;
    };
  }, [addressId]);

  const handleEdit = () => {
    if (!addressData) {
      alert("Brak danych do edycji");
      return;
    }
    // Navigate to edit page, passing addressData via state
    navigate(`/information/${addressId}/edit`, { 
      state: { addressData } 
    });
  };

  const renderContent = () => {
    if (loading) {
      return (
      <div
        className="w-100 d-flex justify-content-center align-items-center"
        style={{ minHeight: "200px" }}
      >
        <Spinner animation="border" />
      </div>
      );
    }
    if (error) return <Alert variant="danger">{error}</Alert>;
    if (!addressData) return <div>Brak danych.</div>;

    switch (activeTab) {
      case "Warstwa adresowa":
        return <AddressLayerData addressData={addressData} />;
      case "Warstwa informacyjna":
        return <InformationLayerData addressData={addressData} />;
      case "Historia zmian":
        return <ChangesHistory addressData={addressData} />;
      default:
        return null;
    }
  };

return (
  <div className="information-layer-container">
    <Container fluid>
      <Row className="mb-4">
        <div>
          <h3 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            Warstwa informacyjna
          </h3>
        </div>
      </Row>
      <Row className="mb-4">
        <Col>
          <div className="tabs-container">
            <div style={{ display: "flex", alignItems: "center" }}>
              <Tab
                label="Warstwa adresowa"
                activeTab={activeTab}
                onClick={() => setActiveTab("Warstwa adresowa")}
              />
              <Tab
                label="Warstwa informacyjna"
                activeTab={activeTab}
                onClick={() => setActiveTab("Warstwa informacyjna")}
              />
              <Tab
                label="Historia zmian"
                activeTab={activeTab}
                onClick={() => setActiveTab("Historia zmian")}
              />
            </div>
            <Button onClick={handleEdit} className="edit-button">
              <img
                src={checkboxIcon}
                alt="Edit"
                style={{ width: "7.9%", height: "7.9%", marginRight: "8px" }}
              />
              Edytuj
            </Button>
          </div>
        </Col>
      </Row>

      <Row className="align-items-start">
        <Col className="d-flex">
          <div className="tab-content-panel w-100">{renderContent()}</div>
        </Col>
        <Col className="d-flex">
          {addressData ? (
            <div className="container w-100">

              <InformationLayerMap   pins={[ { x: addressData.coordX, y: addressData.coordY } ]} />
            </div>
          ) : (
            <div
              className="container w-100 d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <Spinner animation="border" />
            </div>
          )}
        </Col>
      </Row>
    </Container>
  </div>
);
};

export default InformationLayer;
